import { createClient } from "@supabase/supabase-js";

// Vite env vars may include surrounding quotes — strip them
const rawUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL || "";
const rawKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY || "";

const supabaseUrl = rawUrl.replace(/^["']|["']$/g, "");
const supabaseAnonKey = rawKey.replace(/^["']|["']$/g, "");

export const isSupabaseConnected = Boolean(supabaseUrl && supabaseAnonKey);

export const supabaseFunctionsBaseUrl = supabaseUrl;
export const supabaseAnonKeyClean = supabaseAnonKey;

export const supabase = isSupabaseConnected
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
      },
    })
  : null;